import React, { Component, useState } from 'react';
import { Grid, Toolbar, Hidden } from '@mui/material';
import IntlMessages from 'lngProvider/IntlMessages';
import configurationService from 'services/ConfigurationService';
import { styled } from '@mui/material/styles';
import { colors } from 'styles/Common';

const StyledToolbar = styled(Toolbar)((
    {
        theme
    }
    ) => {
        return {
            position: 'fixed',
            left: 0,
            bottom: 0,
            minHeight: '50px !important',
            height: '50px !important',
            width: '100%',
            fontSize: '12px',
            zIndex: 1000,
            [theme.breakpoints.down('xs')]: {
                fontSize: 10
            },
            backgroundColor: colors.fillWhite,
            '& a': {
                color: colors.fillGray70
            }
        };
    });

const Footer = (props) => {
    const [year] = useState(new Date().getFullYear());

    return (
        <footer id="footer">
            <StyledToolbar>
                <Grid container>
                    <Grid item container xs={6} alignContent="center" justifyContent="flex-start">
                        {!window.utag_cfg_ovrd || !window.utag_cfg_ovrd.noload ? 
                            <span><a href="/#" onClick={(e) => { e.preventDefault(); window.utag.gdpr.showConsentPreferences(); }}><IntlMessages id="footer.preferences" /></a></span>
                        : null}
                    </Grid>
                    <Grid item container xs={6} alignContent="center" justifyContent="flex-end">
                        <IntlMessages id="footer.copyright" values={{ year: year }} />
                        <Hidden xsDown>
                            {
                                // Do not show environment name in production
                                (props.environment === 'Production') ?
                                    null
                                    :
                                    <span className="hidden-xs">&ndash;{props.environment}</span>
                            }
                        </Hidden>
                    </Grid>
                </Grid>
            </StyledToolbar>
        </footer>
    );
};

export default class FooterWrapper extends Component {
    state = {
        environment: ''
    };

    render() {
        return (
            <div>
                <Footer environment={this.state.environment} onShowTerms={this.showTerms} />
            </div>
        );
    }


    componentDidMount() {
        this.getEnvironment();
    }

    async getEnvironment() {
        let config = await configurationService.getConfiguration();
        if (config.environment === 'Dev' || config.environment === 'Development') {
            this.setState({ environment: 'Development' });
        } else if (config.environment === 'Test') {
            this.setState({ environment: 'QA' });
        } else if (config.environment === 'Stage') {
            this.setState({ environment: 'Stage' });
        } else if (config.environment === 'Production') {
            this.setState({ environment: 'Production' });
        } else {
            this.setState({ environment: '' });
        }
    }
}